// extracted by mini-css-extract-plugin
export default {"info-cards":"info-cards--IPH3V"};